// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EcQU","col":"styles_col__3ko7B","actions":"styles_actions__1Kq22","conflict":"styles_conflict__1uZYk"};